module.exports = __webpack_public_path__ + "img/customize_need.fba8412b.svg";